import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';
import {DateFormat} from "../../../settings/DateFormat/DateFormat";

export const ProductoTiendaService = {
	Listar: (filtro, paginacion) => {
		let params = {
			filtro: {
				clave: filtro.clave || null,
				producto: filtro.producto || null,
				activo: filtro.activo || null
			},
			paginacion: {
				total: paginacion.total || null,
				page: paginacion.page || null,
				limit: paginacion.limit || null
			}
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Producto_Tienda_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let fecha_oferta = (form.fecha_oferta || null) ? DateFormat.FormatSql(form.fecha_oferta) : null;
		
		let params = {
			id_producto_tienda: form.id_producto_tienda,
			id_cat_grupo: form.id_cat_grupo,
			id_cat_categoria: form.id_cat_categoria,
			clave: form.clave,
			producto: form.producto,
			descripcion: form.descripcion,
			cantidad: form.cantidad,
			variantes: form.variantes,
			precio_unitario: form.precio_unitario,
			codigo_descuento: form.codigo_descuento,
			imagenes: form.imagenes,
			mini_descripcion: form.mini_descripcion,
			descuento: form.descuento,
			fecha_oferta: fecha_oferta,
			nuevo: form.nuevo,
			activo: form.activo ? 1 : 0,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Producto_Tienda_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let fecha_oferta = (form.fecha_oferta || null) ? DateFormat.FormatSql(form.fecha_oferta) : null;
		
		let params = {
			id_producto_tienda: form.id_producto_tienda,
			id_cat_grupo: form.id_cat_grupo,
			id_cat_categoria: form.id_cat_categoria,
			clave: form.clave,
			producto: form.producto,
			descripcion: form.descripcion,
			cantidad: form.cantidad,
			variantes: form.variantes,
			precio_unitario: form.precio_unitario,
			codigo_descuento: form.codigo_descuento,
			imagenes: form.imagenes,
			mini_descripcion: form.mini_descripcion,
			descuento: form.descuento,
			fecha_oferta: fecha_oferta,
			nuevo: form.nuevo,
			activo: form.activo ? 1 : 0,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Producto_Tienda_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	ModificarCatalogo: (form) => {
		let params = {
			imagen_archivo: form.imagen_archivo,
			imagen_formato: form.imagen_formato,
			activo: form.activo ? 1 : 0,
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Producto_Tienda_Modificar_Catalogo', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_producto_tienda) => {
		let params = {
			id_producto_tienda: id_producto_tienda
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Producto_Tienda_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Codigo: (id_producto_tienda) => {
		let params = {
			id_producto_tienda:id_producto_tienda
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Producto_Tienda_Codigo', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
